import { render, staticRenderFns } from "./GroupDetail.vue?vue&type=template&id=2043e764&scoped=true"
import script from "./GroupDetail.vue?vue&type=script&lang=js"
export * from "./GroupDetail.vue?vue&type=script&lang=js"
import style0 from "./GroupDetail.vue?vue&type=style&index=0&id=2043e764&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2043e764",
  null
  
)

export default component.exports